import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminCommsPhase2 = lazy(() => import("@/pages/admin/AdminCommsPhase2"));

export const Route = createFileRoute("/admin/comms-control")({
  component: AdminCommsPhase2,
});
